import { SwiperSlide } from 'swiper/react';
import { ButtonLink } from '@/components/ui';
import { useSelector } from 'react-redux';
import AgencyCard from '../../cards/agencyCard/AgencyCard';
import { useEffect, useState } from 'react';
import Slider from '../Slider';
import {
	getUserCurrentCity,
	getUserCurrentDistrict,
} from '@/stores/slices/userSlice';
import { showFilter } from '@/stores/slices/showFilterSlice';
import { makeRequest } from '@/services/makeRequest';
import useLadyService from '@/services/LadyService';

import './BestCityAgencySlider.scss';
import { useTranslation } from 'react-i18next';
import { getAgencies } from '../../../stores/slices/agencySlice';
import { useFilterLogicContext } from '@/components/filter/FilterLogicProvider';

const BestCityMassageSlider = () => {
	const { region, lang } = useLadyService();

	const { t } = useTranslation('translation');
	const agencies = useSelector(getAgencies);
	const FILTER = useFilterLogicContext();

	const [isRenderElem, setIsRenderElem] = useState(true);

	const city = useSelector(getUserCurrentCity);
	const cityId = city.id;
	const currentDistrict = useSelector(getUserCurrentDistrict);

	const isBigFilterShow = useSelector(showFilter);

	const [page, setPage] = useState(1);

	const [data, setData] = useState(agencies ? agencies?.agencies : []);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const route = `agencies`;
				const method = 'GET';
				const payload = { page, massage: '1', city: cityId };

				const data = await makeRequest({ route, method, payload });
				if (data) {
					const result = data.agencies;
					setData(result);
				}
			} catch (error) {}
		};

		lang && cityId && !isBigFilterShow && fetchData();
	}, [cityId, lang]);

	useEffect(() => {
		if (FILTER.isFilterEmpty) {
			setIsRenderElem(false);
		} else {
			setIsRenderElem(true);
		}
	}, [data, FILTER.filterStateIndicator]);

	useEffect(() => {}, [isRenderElem]);

	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');

	if (isRenderElem && data?.length > 0) {
		return (
			<div className={'best-agency__container'}>
				<h2 className="title_h2">
					{t('h2massage', {
						Country:
							city.title +
							(currentDistrict?.name
								? ` ${currentDistrict?.name}`
								: ''),
					})}
				</h2>
				{!isJsdom ? (
					<Slider type={'agency'}>
						{data.map((item) => {
							return (
								<SwiperSlide key={item.id}>
									<AgencyCard props={item} />
								</SwiperSlide>
							);
						})}
					</Slider>
				) : (
					<div className={'agencies__container'}>
						<div className="grid-cards">
							{data?.length > 0 &&
								data.map((data) => (
									<AgencyCard
										props={data}
										key={data.id}
									/>
								))}
						</div>
					</div>
				)}

				<div className="d-flex align-center">
					<ButtonLink
						href={`/${lang}/massagebrothels`}
						clazz={'button--secondary best-agency__button td-none'}
						size={'l'}
					>
						{t('allstudios')}
					</ButtonLink>
				</div>
			</div>
		);
	}
};

export default BestCityMassageSlider;
